// extracted by mini-css-extract-plugin
module.exports = {"flashcard":"FlashcardViewerPage_flashcard__XZSRg","img_full_width":"FlashcardViewerPage_img_full_width__2qs6x"};